export default {"src":"/_next/static/media/chevron--horizontal.f2c9aedc.svg","height":32,"width":32};